<template>
  <div class="hello">

    <div class="container">
      <div class="row">
        <div class="col-sm-4">
          <h3>Jeugdverzetten</h3>
          <p>Bij wielrennen, veldrijden en op de baan krijgen jeugdrenners te maken met regels die het gebruikte verzet beperken</p>
          <p>We zien dat dit vaak problemen of uitdagingen oplevert. Hoe werkt het? Voor de categorie en discipline waar je in rijdt,
          geldt een maximum. Dit is een afstand in centimeters die je met één hele pedaalomwenteling op het zwaarste verzet af mag leggen.</p>
          <p>Vaak wordt nog gedacht dat alleen maar het verzet van belang is, maar om de maat van de band is van belang.</p>
          <p>Met een 25mm band is de omtrekt van het wiel groter dan met een 23mm band. En zelfs kan de druk van belang zijn.
            Dit laatste zie je vooral in het veldrijden, waar vaak met heel lage bandendruk wordt gereden. Ook moet je er
          rekening mee houden dat de de omtrent ook verschillend kan zijn tussen diverse banden van verschillende types
        of merken met dezelfde maatvoering</p>
        </div>
        <div class="col-sm-4">
          <h3>Opmeten</h3>
          <p>Zelfs als je wil gaan rekenen met verzetten, zul je eerst de omtrek van het wiel met band op moeten meten.
            En het beste doe je dat door met de fiets door een smal gootje te rijden. Ze het ventiel van het achterwiel
            onder, markeer dat punt en rij dan tot het ventiel weer onder staat. Markeer ook dat punt en meet de afstand
            tussen beide punten</p>
            <p>Voor de rekenmodule die hiernaast staat hebben wij een paar banden opgemeten, zodat je een goede indicatie
              krijgt van de omtrek.</p>
            <p>In de module kun je ook kiezen tussen 'narrow-wide' en 'normaal' kettingblad. Een narrow-wide kettingblad
              is gemaakt om zonder derailleur als enkel kettingblad gebruikt te kunnen worden. Dit heeft allerlei voordelen,
              maar ook één belangrijke beperking: de techniek heeft tot gevolg dat het aantal tanden altijd even is.</p>
              <p>De module geeft uiteindelijk een goede indicatie, maar zekerheid heb je pas als je alles zelf opmeet of op
                laat meten. Bij fietsen waar wij verzetten en/of banden monteren, meten wij als dat gevraagd wordt de
                waardes op.</p>
        </div>
        <div class="col-sm-4">
          <h3>Rekenmodule</h3>
          <form class="form-horizontal">
            <div class="form-group">
              <label class="control-label" for="limiet">Limiet (m):</label>
                <input type="text" class="form-control" id="limiet" v-model.lazy="limiet">
                <select class="form-control" v-model.lazy="limietUitLijst">
                  <option v-for="l in limieten" :value="l.limiet">{{l.tekst}}</option>
                </select>
              <label class="control-label" for="limiet">Wielomtrek (m):</label>
              <input type="text" class="form-control" id="limiet" v-model.lazy="omtrek">
              <select class="form-control" v-model.lazy="omtrekUitLijst">
                <option v-for="l in banden" :value="l.omtrek">{{l.naam}}</option>
              </select>
              <div class="checkbox">
                <label><input type="checkbox" v-model="narrowWide">Narrow-Wide</label>
              </div>
            </div>
          </form>
          <label class="control-label">Mogelijke verzetten:</label>
          <table class="table table-bordered">
            <thead>
              <th>Blad</th>
              <th>Krans</th>
              <th>Marge (cm)</th>
            </thead>
            <tr v-for="v in verzetten">
              <td>{{v.blad}}</td>
              <td>{{v.krans}}</td>
              <td>{{v.marge}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'verzetten',
  created: function () {
    this.updateVerzetten()
  },
  data () {
    return {
      omtrekUitLijst: null,
      limietUitLijst: null,
      limieten: [
        {
          tekst: 'NL-Weg/Baan Cat 1,2',
          limiet: 5.46
        },
        {
          tekst: 'NL-Weg/Baan Cat 3,4',
          limiet: 5.78
        },
        {
          tekst: 'NL-Weg/Baan Cat 5,6',
          limiet: 6.14
        },
        {
          tekst: 'NL-Weg/Baan Cat 7',
          limiet: 6.55
        },
        {
          tekst: 'NL-Weg/Baan Cat Nieuwelingen',
          limiet: 7.01
        },
        {
          tekst: 'NL-Weg/Baan Cat Junioren',
          limiet: 7.93
        },
        {
          tekst: 'NL-Veld Cat 1,2',
          limiet: 5.22
        },
        {
          tekst: 'NL-Veld Cat 3,4',
          limiet: 5.52
        },
        {
          tekst: 'NL-Veld Cat 5,6',
          limiet: 5.87
        },
        {
          tekst: 'NL-Veld Cat 7',
          limiet: 6.26
        },
        {
          tekst: 'NL-Veld Cat 1,2 (2019)',
          limiet: 5.61
        },
        {
          tekst: 'NL-Veld Cat 3,4 (2019)',
          limiet: 5.94
        },
        {
          tekst: 'NL-Veld Cat 5,6 (2019)',
          limiet: 6.31
        },
        {
          tekst: 'NL-Veld Cat 7 (2019)',
          limiet: 6.73
        },
        {
          tekst: 'DE-Rad/Bahn U11',
          limiet: 5.66
        },
        {
          tekst: 'DE-Rad U13',
          limiet: 5.66
        },
        {
          tekst: 'DE-Bahn U13',
          limiet: 6.10
        },
        {
          tekst: 'DE-Rad U15',
          limiet: 6.10
        },
        {
          tekst: 'DE-Bahn U15',
          limiet: 6.45
        },
        {
          tekst: 'DE-Rad/Bahn U17',
          limiet: 7.01
        },
        {
          tekst: 'DE-Rad U19',
          limiet: 7.93
        },
        {
          tekst: 'FR-Poussin/Pupille',
          limiet: 5.6
        },
        {
          tekst: 'FR-Benjamin',
          limiet: 6.4
        },
        {
          tekst: 'FR-Minime',
          limiet: 7.01
        },
        {
          tekst: 'DAN U11/U13 weg',
          limiet: 5.89
        },
        {
          tekst: 'DAN U15 weg',
          limiet: 6.35
        },
        {
          tekst: 'BE U9/U10/U11 weg',
          limiet: 5.45
        },
        {
          tekst: 'BE U12/U13 weg',
          limiet: 5.69
        },
        {
          tekst: 'BE U14/U15 weg',
          limiet: 6.4
        }
      ],
      banden: [
        {
          naam: 'Vittoria 700x22C',
          omtrek: 2.105
        },
        {
          naam: 'Specialized 700x24C',
          omtrek: 2.123
        },
        {
          naam: 'Vredestein 700x23C',
          omtrek: 2.115
        },
        {
          naam: 'Vittoria 700x25C',
          omtrek: 2.13
        },
        {
          naam: '700x26C',
          omtrek: 2.14
        },
        {
          naam: '700x28C',
          omtrek: 2.15
        },
        {
          naam: 'Cross 33mm',
          omtrek: 2.17
        }
      ],
      verzetten: [],
      omtrek: null,
      limiet: null,
      kransMin: 11,
      kransMax: 18,
      bladMin: 28,
      bladMax: 52,
      narrowWide: false,
      assortiment: [
        {naam: 'Cassettes en kettingbladen'},
        {naam: 'Crankstellen en pedalen'},
        {naam: 'Kettingbladen'},
        {naam: 'Groepsets en onderdelen'},
        {naam: 'Remmen'},
        {naam: 'Wielen'},
        {naam: 'Sturen, stuurpennen, zadelpennen'},
        {naam: 'Banden'}
      ]
    }
  },
  methods: {
    updateVerzetten: function () {
      if (
        (Number(this.$data.limiet) === 0) ||
        (Number(this.$data.omtrek) === 0)
      ) {
        this.$data.verzetten = []
      } else {
        this.$data.verzetten = []
        for (var i = this.$data.kransMin; i <= this.$data.kransMax; i++) {
          var b = Math.floor(this.$data.limiet / this.$data.omtrek * i)
          if (this.$data.narrowWide) {
            if ((b % 2) === 1) {
              b = b - 1
            }
          }
          var m = Math.round(1000 * (this.$data.limiet - this.$data.omtrek * b / i)) / 10
          this.$data.verzetten.push(
            {
              blad: b,
              krans: i,
              marge: m
            }
          )
        }
      }
    }
  },
  watch: {
    omtrekUitLijst (val) {
      this.$data.omtrek = val
    },
    limietUitLijst (val) {
      this.$data.limiet = val
    },
    omtrek: function (val) {
      this.updateVerzetten()
    },
    limiet: function (val) {
      this.updateVerzetten()
    },
    narrowWide: function (val) {
      this.updateVerzetten()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// Verzetten.vue?18500ad6